import {Component, OnInit} from '@angular/core';
import {EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
	selector: 'app-quickorder-oo-popup',
	templateUrl: './quickorder-oo-popup.component.html',
	styleUrls: ['./quickorder-oo-popup.component.scss'],
})
export class QuickorderOoPopupComponent implements OnInit {
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;

	constructor(
		public dialog: MatDialogRef<any>,
	) {
	}

	public ngOnInit(): void {
	}
}
